import { render, staticRenderFns } from "./Scroller.vue?vue&type=template&id=358f8d5a&scoped=true&"
import script from "./Scroller.vue?vue&type=script&lang=js&"
export * from "./Scroller.vue?vue&type=script&lang=js&"
import style0 from "./Scroller.vue?vue&type=style&index=0&id=358f8d5a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f8d5a",
  null
  
)

export default component.exports